module.exports = __webpack_public_path__ + "media/images/emoticons/cat-c6b124fc94aafdce040e2823776df738.gif";